import React from 'react';

function ArticleSearch(props) {


  return (
    <div className="container">
      <p className='title mt-2 is-size-5 has-text-centered'>Search Articles</p>
      <div className="columns">
        <div className="column is-8">
          <div className="field">
            <p className="control has-icons-left">
              <input className="input" type="search" placeholder="Search" onChange={(e) => { props.setKeyword(e.target.value) }} />
              <span className="icon is-small is-left">
                <i className="fas fa-search"></i>
              </span>
            </p>
          </div>
        </div>
        <div className="column is-4">
          <button className="button btn" onClick={() => { props.handleSearch() }}>Search</button>
        </div>
      </div>
    </div>
  )
}

export default ArticleSearch;